import { useState } from 'react'
import uniqid from 'uniqid'
import StackIcon from 'tech-stack-icons';
import { skills } from '../../portfolio'
import './Skills.css'

const Skills = () => {
  const [activeTab, setActiveTab] = useState('backend')

  const skillCategories = [
    { key: 'backend', label: 'Backend', icon: '⚙️' },
    { key: 'frontend', label: 'Frontend', icon: '💻' },
    { key: 'databases', label: 'Databases', icon: '🗃️' },
    { key: 'devops', label: 'DevOps', icon: '🚀' },
    { key: 'tools', label: 'Tools', icon: '🔧' }
  ]

  const getCurrentSkills = () => skills[activeTab] || []

  return (
    <section className='section skills' id='skills'>
      <h2 className='section__title'>Skills</h2>
      
      <div className='skills__tabs'>
        {skillCategories.map((category) => (
          <button
            type="button"
            key={category.key}
            className={`skills__tab ${activeTab === category.key ? 'skills__tab--active' : ''}`}
            onClick={() => setActiveTab(category.key)}
          >
            <span className='skills__tab-icon'>{category.icon}</span>
            <span className='skills__tab-label'>{category.label}</span>
          </button>
        ))}
      </div>

      <div className='skills__content'>
        <ul className='skills__list'>
          {getCurrentSkills().map((skill) => (
            <li key={uniqid()} className='skills__list-item'>
              <StackIcon name={skill.icon} className='icon-small' /> 
              <span className='skills__name'>{skill.name}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Skills
